export function getPercentText(percent: number): string {
  return `${Math.round(percent * 100)}%`
}
